module.exports = __webpack_public_path__ + "static/media/logo.c669a968.png";